var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.execTest
      ? _c("div", [
          _c(
            "div",
            [
              _c("label", [_vm._v("设备连接方式：")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "el-select-group el-select",
                  model: {
                    value: _vm.currConnStyle,
                    callback: function ($$v) {
                      _vm.currConnStyle = $$v
                    },
                    expression: "currConnStyle",
                  },
                },
                _vm._l(_vm.connectStyle, function (op, value) {
                  return _c("el-option", {
                    key: value,
                    attrs: { label: op.text, value: op.value },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c("label", [_vm._v("地址：")]),
              _c("el-input", {
                staticClass: "el-input--small",
                staticStyle: { width: "auto" },
                attrs: { value: "", placeholder: "连接地址" },
                model: {
                  value: _vm.connAddr,
                  callback: function ($$v) {
                    _vm.connAddr = $$v
                  },
                  expression: "connAddr",
                },
              }),
              _vm._v(" "),
              _c("label", [_vm._v("端口：")]),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "el-input--small",
                staticStyle: { width: "auto" },
                attrs: { "aria-placeholder": "连接端口" },
                model: {
                  value: _vm.connPort,
                  callback: function ($$v) {
                    _vm.connPort = $$v
                  },
                  expression: "connPort",
                },
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "info" },
                  on: {
                    click: function ($event) {
                      return _vm.connectDevice()
                    },
                  },
                },
                [_vm._v("连接")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.disconnectDevice()
                    },
                  },
                },
                [_vm._v("断开")]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "connStatus" }, [
                _vm._v(_vm._s(_vm.connStatus)),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("label", [_vm._v("设备型号：")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "el-select el-select-group",
                  model: {
                    value: _vm.currDeviceModel,
                    callback: function ($$v) {
                      _vm.currDeviceModel = $$v
                    },
                    expression: "currDeviceModel",
                  },
                },
                _vm._l(_vm.deviceModels, function (op, value) {
                  return _c("el-option", {
                    key: value,
                    attrs: { label: op.text, value: op.value },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "info" },
                  on: {
                    click: function ($event) {
                      return _vm.queryTestList()
                    },
                  },
                },
                [_vm._v("获取测试列表")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "info" },
                  on: {
                    click: function ($event) {
                      return _vm.testStart()
                    },
                  },
                },
                [_vm._v("开始测试")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.testStop()
                    },
                  },
                },
                [_vm._v("结束测试")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "connStatus" }, [
                _vm._v(_vm._s(_vm.testResult)),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "deviceTestList" } },
            [
              _c("label", [_vm._v("设备测试列表：")]),
              _c("br"),
              _vm._v(" "),
              _c(
                "el-table",
                { attrs: { data: _vm.deviceTestList } },
                [
                  _c("el-table-column", { attrs: { prop: "id", label: "id" } }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "简述" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "content", label: "描述" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "model", label: "型号" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "manual",
                      label: "是否人工判定",
                      formatter: _vm.formatBoolean,
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "step", label: "测试步骤", size: "100" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "preResult", label: "预置结果" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "realResult",
                      label: "实际结果(人工填写)",
                      hidden: "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.manual
                                ? _c("el-input", {
                                    staticClass: "el-input--small",
                                    staticStyle: { width: "auto" },
                                    attrs: { placeholder: "结果数据" },
                                    model: {
                                      value: scope.row.realResult,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "realResult", $$v)
                                      },
                                      expression: "scope.row.realResult",
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3600569446
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { fixed: "right", label: "操作" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.manual === false
                                ? _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.testIt(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("自动测试")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.manual
                                ? _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.testManualStart(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("人工测试")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.manual
                                ? _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.testManualDone(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("测试结果提交")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("label", [_vm._v(_vm._s(scope.row.opResult))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1217420194
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }